import React from "react";
import { Link } from "react-router-dom";
//import day1notes from "../../../../assets/notes/Day1_Python_basics.pdf";
//import sample from "../../../../assets/notes/Lecture-2-Python-Basics.html";

const PythonTopics = () => {
  return (
    <section className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="text-center mb-20">
          <h1 className="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
            Complete Python Course
          </h1>
          <p className="text-justify text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
            Welcome to our Complete Python Programming Course, designed to take
            you from a beginner to an expert in Python programming. Whether
            you're new to coding or looking to enhance your skills, this course
            provides a thorough understanding of Python, one of the most popular
            and versatile programming languages. And this is absolutly FREE!!
          </p>
        </div>
        <p>
          Visit for Python IDE installation guide:
          <Link to="/ideguide">Software installation steps</Link>
        </p>

        <div className="bg-gray-100 p-10">
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse bg-white shadow-md rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-blue-500 text-white">
                  <th className="py-3 px-6 text-left font-semibold">
                    Python Topic
                  </th>
                  <th className="py-3 px-6 text-left font-semibold">
                    Resource Link
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 1, Introduction to Python
                  </td>
                  <td className="py-4 px-6 border-b">
                    {/* <a href={day1notes} target="_blank">
                      Notes
                    </a> */}
                    {/* <a
                      href="notes/Day-1-Python_Introduction.html"
                      target="_blank"
                    >
                      Notes
                    </a> */}
                    No Notes
                  </td>
                </tr>
                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 2, Python Data Types
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a
                      href="notes/Day-2-Python_Data_Types.html"
                      target="_blank"
                    >
                      Notes
                    </a>
                  </td>
                </tr>

                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 3, Strings in Python
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a href="notes/Day-3_String_Concepts.html" target="_blank">
                      Notes
                    </a>
                  </td>
                </tr>
                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 4, Operators in Python
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a
                      href="notes/Day-4_Operators_in_Python.html"
                      target="_blank"
                    >
                      Notes
                    </a>
                  </td>
                </tr>
                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 5, Conditional Operators and Match-case in Python
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a
                      href="notes/Day-5_Conditional-statements_Match-case-statements.html"
                      target="_blank"
                    >
                      Notes
                    </a>
                  </td>
                </tr>
                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 6, Python Loops Concept
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a
                      href="notes/Day-6_Python-Loops_concepts.html"
                      target="_blank"
                    >
                      Notes
                    </a>
                  </td>
                </tr>

                {/* <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 4, Conditional statements in Python
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a
                      href="notes/Day-4-Conditional_Statements.html"
                      target="_blank"
                    >
                      Notes
                    </a>
                  </td>
                </tr>

                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">Day 5, Loops in Python</td>
                  <td className="py-4 px-6 border-b">
                    <a href="notes/Day-5-Loops-in-Python.html" target="_blank">
                      Notes
                    </a>
                  </td>
                </tr>
                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 6, Data Structure - List in Python
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a
                      href="notes/Day-6-Data-Structure-concept-List.html"
                      target="_blank"
                    >
                      Notes
                    </a>
                  </td>
                </tr>

                <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">
                    Day 7, Data Structure - Tuples in Python
                  </td>
                  <td className="py-4 px-6 border-b">
                    <a href="notes/Day-7-Tuples.html" target="_blank">
                      Notes
                    </a>
                  </td>
                </tr> */}

                {/* <tr className="hover:bg-gray-100">
                  <td className="py-4 px-6 border-b">Row 3, Data 1</td>
                  <td className="py-4 px-6 border-b">Row 3, Data 2</td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </div>

        {/* <div className="flex flex-wrap -m-4">
          <div className="p-4 lg:w-1/4 sm:w-1/2 w-full">
            <h2 className="font-medium title-font tracking-widest text-gray-900 mb-4 text-sm text-center sm:text-left">
              BEGINNER LEVEL
            </h2>
            <nav className="flex flex-col sm:items-start sm:text-left text-center items-center -mb-1 space-y-2.5">
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                <Link to="/pyleacture1">Day - 1 Link</Link>
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                <Link to="/pyleacture2">
                  Day - 2 Python Variables and Naming conventions
                </Link>
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                <Link to="/pyleacture3">Day - 3 Python Basic Data Types</Link>
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 4 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 5 Link
              </a>

              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - .. Link
              </a>
            </nav>
          </div>
          <div className="p-4 lg:w-1/4 sm:w-1/2 w-full">
            <h2 className="font-medium title-font tracking-widest text-gray-900 mb-4 text-sm text-center sm:text-left">
              INTERMEDIATE LEVEL
            </h2>
            <nav className="flex flex-col sm:items-start sm:text-left text-center items-center -mb-1 space-y-2.5">
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day -1 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day -2 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 3 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 4 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 5 Link
              </a>

              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - .. Link
              </a>
            </nav>
          </div>
          <div className="p-4 lg:w-1/4 sm:w-1/2 w-full">
            <h2 className="font-medium title-font tracking-widest text-gray-900 mb-4 text-sm text-center sm:text-left">
              ADVANCED LEVEL
            </h2>
            <nav className="flex flex-col sm:items-start sm:text-left text-center items-center -mb-1 space-y-2.5">
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 1 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 2 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 3 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 4 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 5 Link
              </a>

              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - .. Link
              </a>
            </nav>
          </div>
          <div className="p-4 lg:w-1/4 sm:w-1/2 w-full">
            <h2 className="font-medium title-font tracking-widest text-gray-900 mb-4 text-sm text-center sm:text-left">
              PYTHON PROJECTS
            </h2>
            <nav className="flex flex-col sm:items-start sm:text-left text-center items-center -mb-1 space-y-2.5">
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 1 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 2 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 3 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 4 Link
              </a>
              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - 5 Link
              </a>

              <a>
                <span className="bg-indigo-100 text-indigo-500 w-4 h-4 mr-2 rounded-full inline-flex items-center justify-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="3"
                    className="w-3 h-3"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
                Day - .. Link
              </a>
            </nav>
          </div>
        </div> */}
        {/* <button className="flex mx-auto mt-16 text-white bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg">
          <Link to="/pyleacture1">TODAY's SESSION</Link>
        </button> */}
        <Link to="/pytopics">
          <button className="flex mx-auto mt-16 text-white bg-blue-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg">
            TODAY's SESSION{" "}
          </button>
        </Link>
      </div>
    </section>
  );
};

export default PythonTopics;
